module.exports = __webpack_public_path__ + "static/img/1901_2.146711f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1901_2.jpg
// module id = ptLN
// module chunks = 1